// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import WeiboSquareFilledSvg from "@fishx/icons-svg/es/asn/WeiboSquareFilled";
import FishxIcon from '../components/FishxIcon';

var WeiboSquareFilled = function WeiboSquareFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: WeiboSquareFilledSvg
  }));
};

WeiboSquareFilled.displayName = 'WeiboSquareFilled';
export default React.forwardRef(WeiboSquareFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/WeiboSquareFilled.js
// module id = 4404
// module chunks = 0